<div class="main-container d-flex align-items-center justify-content-center">
  <div class="content-wrapper">
    <!-- Logo centrado arriba -->
    <div class="img-documents-container text-center mb-4">
      <img src="../../../../assets/images/logo-dark.png" alt="Logo">
    </div>

    <!-- ============================================ -->
    <!-- MODO MULTI-ORDEN (supplier-update / batch)   -->
    <!-- ============================================ -->
    <ng-container *ngIf="isMultiMode && !isLoading && !errorMessage">

      <!-- Cabecera -->
      <div class="page-header text-center">
        <h1 class="supplier-name" *ngIf="supplierName">{{ supplierName }}</h1>
        <p class="header-title">{{ "public_supplier.confirm_delivery_title" | translate }}</p>
        <p class="header-subtitle">{{ "public_supplier.confirm_delivery_subtitle" | translate }}</p>
        <p class="orders-count" *ngIf="orders.length > 0" style="color:var(--color-gray-500,#6c757d);font-size:0.9rem;">
          {{ orders.length }} {{ "reports.pending_orders" | translate | lowercase }}
        </p>
      </div>

      <!-- Estado vacío -->
      <div *ngIf="orders.length === 0" class="text-center py-5">
        <i class="icon-inbox" style="font-size:3rem;color:var(--color-gray-300,#ccc);"></i>
        <p class="mt-3" style="color:var(--color-gray-500,#6c757d);">{{ "reports.no_pending_orders" | translate }}</p>
      </div>

      <!-- Toolbar: búsqueda + ordenamiento + grilla -->
      <div class="supplier-toolbar" *ngIf="orders.length > 0">
        <div class="toolbar-search">
          <i class="icon-search toolbar-search-icon"></i>
          <input type="text" class="toolbar-search-input" [(ngModel)]="searchText"
            [placeholder]="'public_supplier.search_placeholder' | translate" />
          <i class="icon-cross toolbar-search-clear" *ngIf="searchText" (click)="clearSearch()"></i>
        </div>
        <div class="toolbar-controls">
          <button type="button" class="toolbar-btn" [title]="('public_supplier.sort_' + sortMode) | translate"
            (click)="toggleSort()">
            <i [class]="sortMode === 'desc' ? 'icon-sort-amount-desc' : 'icon-sort-amount-asc'"></i>
          </button>
          <div class="toolbar-grid-btns">
            <button type="button" class="toolbar-btn" [class.active]="gridCols === 1" (click)="setGridCols(1)">
              <i class="icon-list"></i>
            </button>
            <button type="button" class="toolbar-btn" [class.active]="gridCols === 3" (click)="setGridCols(3)">
              <i class="icon-grid"></i>
            </button>
          </div>
        </div>
        <div class="toolbar-count" *ngIf="searchText">
          {{ "public_supplier.showing_results" | translate: { count: visibleOrders.length, total: orders.length } }}
        </div>
      </div>

      <!-- Cards de órdenes en grilla -->
      <div class="orders-grid" [ngClass]="'cols-' + gridCols">
      <div class="order-card-container" *ngFor="let order of visibleOrders">
        <div class="order-card">

          <!-- Fila 1: Cliente o referencia broker -->
          <div class="client-row">
            <h2 class="client-name" *ngIf="order.data.client_name">{{ order.data.client_name }}</h2>
            <h2 class="client-name" *ngIf="!order.data.client_name && order.data.broker_reference">
              {{ "inputs.broker_reference" | translate }}: {{ order.data.broker_reference }}
            </h2>
            <h2 class="client-name" *ngIf="!order.data.client_name && !order.data.broker_reference">
              {{ order.data.reference }}
            </h2>
          </div>

          <!-- Fila 2: Tax ID + Referencias -->
          <div class="references-row">
            <span class="ref-item" *ngIf="order.data.client?.tax_id">
              <i class="icon-user"></i> {{ order.data.client.tax_id }}
            </span>
            <span class="ref-item" *ngIf="order.data.broker_reference">
              <i class="icon-tag"></i> {{ order.data.broker_reference }}
            </span>
            <span class="ref-item" *ngIf="order.data.supplier_reference">
              <i class="icon-barcode"></i> {{ order.data.supplier_reference }}
            </span>
            <span class="ref-item" *ngIf="order.data.vendor_reference">
              <i class="icon-barcode"></i> {{ order.data.vendor_reference }}
            </span>
            <span class="ref-item" *ngIf="order.data.contract_signed_date">
              <i class="icon-calendar"></i> {{ order.data.contract_signed_date | date:'dd/MM/yy' }}
            </span>
            <span class="ref-item" *ngIf="order.data.stage">
              <span class="badge bg-primary" style="font-size:0.75rem;">
                {{ "badge-status_select-stage." + order.data.stage | translate }}
              </span>
            </span>
          </div>

          <!-- Fila 3: Vehículo (izq) + Bastidor/Matrícula (der) -->
          <div class="vehicle-section">
            <div class="vehicle-left">
              <span class="vehicle-model">{{ order.data.vehicle || '—' }}</span>
              <span class="vehicle-brand-model" *ngIf="order.data.vehicle_brand || order.data.vehicle_model">{{ order.data.vehicle_brand }} {{ order.data.vehicle_model }}</span>
              <div class="vehicle-tags">
                <span *ngIf="order.data.vehicle_status" class="badge text-badge-list"
                  [ngClass]="order.data.vehicle_status | badgeVehicle">
                  {{ "badge-status_select-stage." + order.data.vehicle_status | translate }}
                </span>
                <span class="vehicle-detail" *ngIf="order.data.colour"><i class="icon-brush2"></i> {{ order.data.colour }}</span>
                <span class="vehicle-detail" *ngIf="order.data.duration">{{ order.data.duration }} {{ "tables.months" | translate }} / {{ order.data.total_kms | number }} km</span>
              </div>
            </div>
            <div class="vehicle-right">
              <div class="vehicle-field" *ngIf="order.data.vin || order.confirmStatus === 'pending'">
                <span class="vehicle-field-label">{{ "inputs.vin" | translate }}</span>
                <div class="vehicle-field-row">
                  <span class="vehicle-field-value">{{ order.data.vin || '—' }}</span>
                  <i class="icon-pencil field-edit-icon" *ngIf="order.confirmStatus === 'pending'"
                    (click)="openFieldEdit(order, 'vin')"></i>
                </div>
                <!-- Popup edición VIN -->
                <div class="field-edit-popup" *ngIf="order.editingField === 'vin'">
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="order.editFieldValue"
                    placeholder="{{ 'inputs.vin' | translate }}" />
                  <div class="field-edit-popup-actions">
                    <a class="link-cancel" (click)="cancelFieldEdit(order)">{{ "public_supplier.cancel" | translate }}</a>
                    <button class="btn btn-save btn-sm" (click)="saveFieldEdit(order)">{{ "public_supplier.save" | translate }}</button>
                  </div>
                </div>
              </div>
              <div class="vehicle-field" *ngIf="order.data.license_plate || order.confirmStatus === 'pending'">
                <span class="vehicle-field-label">{{ "inputs.license_plate" | translate }}</span>
                <div class="vehicle-field-row">
                  <span class="vehicle-field-value">{{ order.data.license_plate || '—' }}</span>
                  <i class="icon-pencil field-edit-icon" *ngIf="order.confirmStatus === 'pending'"
                    (click)="openFieldEdit(order, 'plate')"></i>
                </div>
                <!-- Popup edición Matrícula -->
                <div class="field-edit-popup" *ngIf="order.editingField === 'plate'">
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="order.editFieldValue"
                    placeholder="{{ 'inputs.license_plate' | translate }}" />
                  <div class="field-edit-popup-actions">
                    <a class="link-cancel" (click)="cancelFieldEdit(order)">{{ "public_supplier.cancel" | translate }}</a>
                    <button class="btn btn-save btn-sm" (click)="saveFieldEdit(order)">{{ "public_supplier.save" | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Fila 4: Previsión actual -->
          <div class="forecast-section">
            <p class="forecast-label">{{ "public_supplier.forecast_label" | translate }}</p>
            <p class="forecast-date" *ngIf="order.data.delivery_expected_date">
              {{ order.data.delivery_expected_date | date:'d MMMM' }}
            </p>
            <p class="forecast-date" *ngIf="!order.data.delivery_expected_date">—</p>

            <!-- Estado: pendiente — solo si hay fecha de última confirmación -->
            <p class="forecast-pending" *ngIf="order.confirmStatus === 'pending' && order.daysSinceUnconfirmed >= 0">
              {{ "public_supplier.unconfirmed_since" | translate: { days: order.daysSinceUnconfirmed } }}
            </p>

            <!-- Estado: confirmado sin cambios -->
            <p class="forecast-confirmed" *ngIf="order.confirmStatus === 'confirmed_no_changes'">
              <i class="icon-checkmark"></i> {{ "public_supplier.confirmed_no_changes" | translate }}
              <a class="link-undo" (click)="undoCard(order)">{{ "public_supplier.undo" | translate }}</a>
            </p>

            <!-- Estado: confirmado con cambios + deshacer -->
            <p class="forecast-confirmed" *ngIf="order.confirmStatus === 'confirmed_with_changes'">
              <i class="icon-checkmark"></i> {{ "public_supplier.new_forecast_confirmed" | translate }}
              <a class="link-undo" (click)="undoCard(order)">{{ "public_supplier.undo" | translate }}</a>
            </p>
          </div>

          <!-- Formulario edición -->
          <div class="edit-section" *ngIf="order.showEditForm">
            <form [formGroup]="order.form">
              <div class="edit-field">
                <label class="form-label">{{ "public_supplier.delivery_expected_date_label" | translate }}</label>
                <mat-form-field appearance="fill" class="w-100">
                  <input matInput [matDatepicker]="picker" formControlName="delivery_expected_date" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="edit-field">
                <label class="form-label">{{ "public_supplier.delivery_status_label" | translate }}</label>
                <select class="form-control form-select" formControlName="delivery_status">
                  <option value="">—</option>
                  <option value="countryside">{{ "pages.deliverys.calendar.status.production" | translate }}</option>
                  <option value="body_shop">{{ "badge-status_select-stage.body_shop" | translate }}</option>
                  <option value="dealership">{{ "badge-status_select-stage.dealership" | translate }}</option>
                  <option value="documentation">{{ "badge-status_select-stage.documentation" | translate }}</option>
                  <option value="production">{{ "badge-status_select-stage.production" | translate }}</option>
                  <option value="delivered">{{ "badge-status_select-stage.vehicle_delivered" | translate }}</option>
                  <option value="factory">{{ "badge-status_select-stage.factory" | translate }}</option>
                  <option value="dealership_accessories">{{ "badge-status_select-stage.dealership_accessories" | translate }}</option>
                  <option value="washing">{{ "badge-status_select-stage.washing" | translate }}</option>
                  <option value="logistics">{{ "badge-status_select-stage.logistics" | translate }}</option>
                  <option value="registered">{{ "badge-status_select-stage.registered" | translate }}</option>
                  <option value="client_requested">{{ "badge-status_select-stage.client_requested" | translate }}</option>
                  <option value="billing">{{ "badge-status_select-stage.billing" | translate }}</option>
                  <option value="registering">{{ "badge-status_select-stage.registering" | translate }}</option>
                  <option value="plates">{{ "badge-status_select-stage.plates" | translate }}</option>
                  <option value="pre_delivery">{{ "badge-status_select-stage.pre_delivery" | translate }}</option>
                  <option value="countryside_conversion">{{ "badge-status_select-stage.countryside_conversion" | translate }}</option>
                  <option value="dealership_conversion">{{ "badge-status_select-stage.dealership_conversion" | translate }}</option>
                  <option value="transport_body_shop">{{ "badge-status_select-stage.transport_body_shop" | translate }}</option>
                </select>
              </div>
              <div class="edit-field">
                <label class="form-label">{{ "public_supplier.notes_label" | translate }}</label>
                <textarea class="form-control" formControlName="notes" rows="3"
                  [placeholder]="'public_supplier.notes_placeholder' | translate"></textarea>
              </div>
              <div class="edit-actions">
                <a class="link-cancel" (click)="cancelCardEdit(order)">{{ "public_supplier.cancel" | translate }}</a>
                <button class="btn btn-save" (click)="updateCard(order)"
                  [disabled]="order.isUpdating || !order.hasChanges">
                  {{ order.isUpdating ? ("public_supplier.saving" | translate) : ("public_supplier.save" | translate) }}
                </button>
              </div>
            </form>
          </div>

          <!-- Botón ENTREGADO — visible cuando fecha prevista superada o a <= 3 días -->
          <div class="delivery-urgent-section" *ngIf="order.deliveryUrgent && order.confirmStatus === 'pending' && !order.showEditForm">
            <div class="delivery-urgent-banner" [ngClass]="order.deliveryOverdue ? 'overdue' : 'upcoming'">
              <i class="icon-truck"></i>
              <span *ngIf="order.deliveryOverdue">{{ "public_supplier.delivery_overdue" | translate }}</span>
              <span *ngIf="!order.deliveryOverdue">{{ "public_supplier.delivery_upcoming" | translate }}</span>
            </div>
            <button class="btn btn-delivered" (click)="markAsDelivered(order)" [disabled]="order.isUpdating">
              <span *ngIf="order.isUpdating" class="spinner"></span>
              <i *ngIf="!order.isUpdating" class="icon-checkmark"></i>
              {{ "public_supplier.mark_as_delivered" | translate }}
            </button>
          </div>

          <!-- Botones confirmar / cambiar (solo si pendiente) -->
          <div class="action-buttons" *ngIf="!order.showEditForm && order.confirmStatus === 'pending'">
            <button class="btn btn-confirm" (click)="confirmCard(order)" [disabled]="order.isUpdating">
              <span *ngIf="order.isUpdating" class="spinner"></span>
              <i *ngIf="!order.isUpdating" class="icon-checkmark"></i>
              {{ order.isUpdating ? ("public_supplier.confirming" | translate) : ("public_supplier.stays_same" | translate) }}
            </button>
            <button class="btn btn-change" (click)="openCardEdit(order)" [disabled]="order.isUpdating">
              <i class="icon-pencil"></i> {{ "public_supplier.change" | translate }}
            </button>
          </div>

        </div>
      </div>
      </div> <!-- /orders-grid -->

    </ng-container>

    <!-- ============================================ -->
    <!-- MODO SINGLE-ORDEN (public update-delivery)   -->
    <!-- ============================================ -->
    <ng-container *ngIf="!isMultiMode && !isLoading && !errorMessage">

      <div class="page-header text-center">
        <h1 class="supplier-name">{{ orderData?.supplier?.name }}</h1>
        <p class="header-title">Confirma por favor la previsión de entrega de las siguientes operaciones</p>
        <p class="header-subtitle">Si todo sigue igual, puedes confirmar cada vehículo con un solo clic</p>
      </div>

      <div class="order-card-container">
        <div class="order-card">

          <div class="client-row">
            <h2 class="client-name">{{ orderData?.client?.name }} {{ orderData?.client?.lastname }}</h2>
          </div>

          <div class="references-row">
            <span class="ref-item">
              <i class="icon-user"></i> {{ orderData?.client?.tax_id }}
            </span>
            <span class="ref-item" *ngIf="orderData?.supplier_reference">
              <i class="icon-barcode"></i> {{ orderData?.supplier_reference }}
            </span>
            <span class="ref-item" *ngIf="orderData?.vendor_reference">
              <i class="icon-barcode"></i> {{ orderData?.vendor_reference }}
            </span>
          </div>

          <div class="vehicle-section">
            <div class="vehicle-left">
              <span class="vehicle-model">{{ orderData?.vehicle }}</span>
              <span class="vehicle-brand-model" *ngIf="orderData?.vehicle_brand || orderData?.vehicle_model">{{ orderData?.vehicle_brand }} {{ orderData?.vehicle_model }}</span>
              <div class="vehicle-tags">
                <span *ngIf="orderData?.vehicle_status" class="badge text-badge-list"
                  [ngClass]="orderData.vehicle_status | badgeVehicle">
                  {{ "badge-status_select-stage." + orderData?.vehicle_status | translate }}
                </span>
                <span class="vehicle-detail"><i class="icon-brush2"></i> {{ orderData?.colour }}</span>
              </div>
            </div>
            <div class="vehicle-right">
              <div class="vehicle-field" *ngIf="orderData?.vin">
                <span class="vehicle-field-label">{{ "inputs.vin" | translate }}</span>
                <span class="vehicle-field-value">{{ orderData?.vin }}</span>
              </div>
              <div class="vehicle-field" *ngIf="orderData?.license_plate">
                <span class="vehicle-field-label">{{ "inputs.license_plate" | translate }}</span>
                <span class="vehicle-field-value">{{ orderData?.license_plate }}</span>
              </div>
            </div>
          </div>

          <div class="forecast-section">
            <p class="forecast-label">Previsión actual</p>
            <p class="forecast-date" *ngIf="orderData?.delivery_expected_date">
              {{ orderData?.delivery_expected_date | date:'d MMMM' }}
            </p>
            <p class="forecast-date" *ngIf="!orderData?.delivery_expected_date">—</p>
            <p class="forecast-pending" *ngIf="daysSinceUnconfirmed > 0">
              Sin confirmar desde hace {{ daysSinceUnconfirmed }} días
            </p>
          </div>

          <div class="edit-section" *ngIf="showEditForm">
            <form [formGroup]="deliveryForm">
              <div class="edit-fields">
                <div class="edit-field">
                  <label class="form-label">{{ "inputs.client_name" | translate }}</label>
                  <input type="text" class="form-control" formControlName="client_name"
                    [class.bg-light]="deliveryForm.get('client_name')?.disabled" />
                </div>
                <div class="edit-field">
                  <label class="form-label">{{ "inputs.delivery_expected_date" | translate }}</label>
                  <mat-form-field appearance="fill" class="w-100">
                    <input matInput [matDatepicker]="delivery_expected_date" formControlName="delivery_expected_date" />
                    <mat-datepicker-toggle matSuffix [for]="delivery_expected_date"></mat-datepicker-toggle>
                    <mat-datepicker #delivery_expected_date></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="edit-field">
                  <label class="form-label">{{ "inputs.supplier_reference" | translate }}</label>
                  <input type="text" class="form-control" formControlName="supplier_reference"
                    [class.bg-light]="deliveryForm.get('supplier_reference')?.disabled" />
                </div>
                <div class="edit-field">
                  <label class="form-label">{{ "inputs.vendor_reference" | translate }}</label>
                  <input type="text" class="form-control" formControlName="vendor_reference"
                    [class.bg-light]="deliveryForm.get('vendor_reference')?.disabled" />
                </div>
                <div class="edit-field">
                  <label class="form-label">{{ "inputs.vin" | translate }}</label>
                  <input type="text" class="form-control" formControlName="vin"
                    [class.bg-light]="deliveryForm.get('vin')?.disabled" />
                </div>
                <div class="edit-field">
                  <label class="form-label">{{ "inputs.license_plate" | translate }}</label>
                  <input type="text" class="form-control" formControlName="license_plate"
                    [class.bg-light]="deliveryForm.get('license_plate')?.disabled" />
                </div>
              </div>
              <div class="edit-actions">
                <button class="btn btn-outline-secondary" (click)="cancelEdit()">Cancelar</button>
                <button class="btn btn-primary btn-primary-form" (click)="updateOrder()"
                  [disabled]="isUpdating || !hasFormChanges">
                  {{ isUpdating ? ('buttons.updating' | translate) : ("buttons.update_order" | translate) }}
                </button>
              </div>
            </form>
          </div>

          <div class="action-buttons" *ngIf="!showEditForm">
            <button class="btn btn-confirm" (click)="confirmDelivery()" [disabled]="isUpdating">
              <i class="icon-checkmark"></i> Sigue igual
            </button>
            <button class="btn btn-change" (click)="openEditForm()">
              <i class="icon-pencil"></i> Cambiar
            </button>
          </div>

        </div>
      </div>

    </ng-container>

    <div *ngIf="isLoading" class="loading text-center">Cargando...</div>
    <div *ngIf="errorMessage" class="error text-center">{{ errorMessage }}</div>
  </div>
</div>
